import Footer from "../../Footer/Footer";
export const Pricing = () => (
  <div>
  <div className="min-h-screen bg-white flex items-center justify-center px-4 py-12">
  <div className="max-w-2xl text-center">
    <h1 className="text-4xl font-bold text-gray-800 mb-4">Subscription Plan</h1>
    
    <p className="text-lg text-purple-600 font-semibold mb-2">
      🎉 Limited-Time Offer! Free for <span className="font-medium text-indigo-600">Beta</span> Version.
    </p>
    
    <p className="text-base text-gray-600 mb-2">
      Our AI finds and applies to jobs for you so you can focus on what matters.
    </p>
    
    <p className="text-base text-gray-600 mb-6">
      Offer ends with our next release — claim it now.
    </p>

    {/* Add pricing plans below here */}
  </div>
</div>
<Footer />
</div>
);